import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Building2, ShieldCheck, HandCoins, HeartHandshake } from "lucide-react";

const PATHS = [
  {
    icon: Building2,
    title: "DODD / County Board",
    color: "#0E5A72",
    body: "HPC · HPC Transportation · NMT · Community Respite · Residential Respite · Shared Living · Participant Directed HPC",
    cta: "REFER A CLIENT",
    to: "/refer",
    testid: "path-dodd",
  },
  {
    icon: ShieldCheck,
    title: "Next Generation MyCare",
    color: "#1B7A98",
    body: "Contact Caregivers Alliance to verify eligibility, service authorization, and current provider/network participation.",
    cta: "VERIFY COVERAGE",
    to: "/mycare",
    testid: "path-mycare",
  },
  {
    icon: HandCoins,
    title: "Private Pay",
    color: "#2E9E6A",
    body: "Services may include Personal Care, Homemaker Support, Companionship, Respite, and Transportation where available.",
    cta: "REQUEST PRIVATE-PAY CONSULTATION",
    to: "/private-pay",
    testid: "path-private",
  },
  {
    icon: HeartHandshake,
    title: "Family Caregiver Options",
    color: "#7C3AED",
    headline: "Already Have Someone You Trust Helping With Care?",
    body: "Some Ohio programs may allow individuals to select a qualified family member, friend, or trusted caregiver. Eligibility depends on the program, waiver, service plan, authorization, relationship, and applicable requirements.",
    cta: "CHECK FAMILY CAREGIVER OPTIONS",
    to: "/family-caregiver",
    testid: "path-family",
  },
];

const FourPaths = () => (
  <section data-testid="four-paths" className="section bg-white -mt-2">
    <div className="mx-auto max-w-7xl px-4">
      <h2 className="font-display font-bold text-2xl md:text-3xl text-[#0E2A33] text-center">How can we help you today?</h2>
      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {PATHS.map((p) => {
          const Icon = p.icon;
          return (
            <div key={p.title} data-testid={p.testid} className="card-hover bg-[#F7FBFC] rounded-2xl border border-slate-100 p-6 flex flex-col">
              <div className="h-11 w-11 rounded-xl grid place-items-center text-white mb-4" style={{ backgroundColor: p.color }}>
                <Icon className="h-5 w-5" />
              </div>
              <h3 className="font-display font-bold text-lg text-[#0E2A33]">{p.title}</h3>
              {p.headline && <div className="text-sm font-semibold text-[#0E5A72] mt-1">{p.headline}</div>}
              <p className="text-sm text-slate-600 mt-2 leading-relaxed flex-1">{p.body}</p>
              <Link to={p.to} className="mt-5">
                <Button className="w-full rounded-full text-white text-xs font-semibold h-10" style={{ backgroundColor: p.color }}>
                  {p.cta}
                </Button>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default FourPaths;
